import { BusinessHoursDisplay } from "../common/BusinessHoursDisplay";
import Button from "../common/Button";
import Container from "../common/Container";
import { Hours } from "../requests/dtos/Hours";
import { Role } from "../userAccess/kiosk/KioskContext";

export type KioskStartProps = {
  role: Role;
  loadoutOpen: boolean;
  receivingOpen: boolean;
  outboundOpen: boolean;
  shutOffAccess: boolean;
  shutOffAccessWhenClosed: boolean;
  loadoutHours?: Hours[];
  receivingHours?: Hours[];
  timeZone: string;
  toInbound: () => void;
  toOutbound: () => void;
}

const BlockButton = ({ onClick, disabled, text }: { onClick: () => void, disabled?: boolean, text: string }) => {
  return <Button className="py-10 w-35" onClick={onClick} disabled={disabled}>
    <blockquote className="blockquote my-7 blockquote-light">
      <h1 className="text-light">{text}</h1>
    </blockquote>
  </Button>
}

export const KioskStart = (props: KioskStartProps) => {
  const getClosedMessage = () => {
    if (props.shutOffAccess || (!props.receivingOpen && !props.loadoutOpen)) {
      return 'Closed';
    }

    if (!props.loadoutOpen && props.receivingOpen) {
      return 'Loadout Closed, Receiving Open';
    }

    if (props.loadoutOpen && !props.receivingOpen) {
      return 'Receiving Closed, Loadout Open';
    }
  }

  const bothClosed = !props.loadoutOpen && !props.receivingOpen;

  const inboundText = props.role === Role.Both ? "Inbound" : "Start";
  const outboundText = props.role === Role.Both ? "Outbound" : "Start";

  return <Container title="Welcome">
    {
      getClosedMessage() &&
      <div className='text-center mt-2'>
        <h1 className="text-danger">{getClosedMessage()}</h1>
      </div>
    }
    <div className={`d-flex justify-content-around ${getClosedMessage() ? 'mt-3' : 'mt-7'}`}>
      {props.role !== Role.Outbound &&
        <BlockButton
          onClick={props.toInbound}
          text={inboundText}
          disabled={
            (bothClosed && props.shutOffAccessWhenClosed) ||
            props.shutOffAccess} />}
      {props.role !== Role.Inbound &&
        <BlockButton
          onClick={props.toOutbound}
          text={outboundText}
          disabled={
            ((bothClosed && props.shutOffAccessWhenClosed) || props.shutOffAccess) &&
            !props.outboundOpen
          }
        />}
    </div>
    <div className="mx-7">
      {
        props.loadoutHours &&
        <BusinessHoursDisplay
          receivingHours={props.receivingHours}
          loadoutHours={props.loadoutHours}
          timeZone={props.timeZone} />
      }
    </div>
  </Container>
}
